export const CARD_PATTERNS = [
  { id: 'solid', label: 'Сплошной' },
  { id: 'gradient', label: 'Градиент', usesGradient: true },
  { id: 'mesh', label: 'Меш', usesGradient: true },
  { id: 'sunset', label: 'Закат', usesGradient: true },
  { id: 'dots', label: 'Точки' },
  { id: 'stripes', label: 'Полосы' },
  { id: 'grid', label: 'Сетка' },
  { id: 'rings', label: 'Кольца' },
  { id: 'diamonds', label: 'Ромбы' },
  { id: 'cross', label: 'Переплет' },
  { id: 'aurora', label: 'Сияние' },
];

const PATTERN_IDS = new Set(CARD_PATTERNS.map((p) => p.id));

const BASE_GRADIENT_PATTERNS = new Set(['gradient', 'mesh', 'sunset']);

export function normalizePatternId(id) {
  return PATTERN_IDS.has(id) ? id : 'solid';
}

export function patternUsesGradient(id) {
  return !!CARD_PATTERNS.find((p) => p.id === normalizePatternId(id))?.usesGradient;
}

export function isBaseGradientPattern(id) {
  return BASE_GRADIENT_PATTERNS.has(normalizePatternId(id));
}

export const GRADIENT_ANGLES = [
  { value: 0, label: '→' },
  { value: 45, label: '↗' },
  { value: 90, label: '↑' },
  { value: 135, label: '↖' },
  { value: 180, label: '←' },
  { value: 225, label: '↙' },
  { value: 270, label: '↓' },
  { value: 315, label: '↘' },
];
